import React from 'react'
import { faSave, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useFormikContext } from 'formik'
import { Address, Dropdown, Input } from 'src/components/Forms'
import { Body, Footer } from 'src/components/theme/Models/Modal'
import { DefaultLookupsReturn, UseLookupsReturn } from '../helpers/useLookups'
import Phone from 'src/components/Forms/Phone'

interface FormProps {
  toggle: () => void
  isLoading?: boolean
  hasError?: boolean
  disableSave?: boolean
  lookups?: UseLookupsReturn
}

const Form: React.FC<FormProps> = (props) => {
  const { hasError, toggle, isLoading, disableSave, lookups = DefaultLookupsReturn } = props
  const { handleSubmit } = useFormikContext()
  return (
    <>
      <Body error={{
        error: 'There was an issue adding the poc.',
        show: hasError ?? false
      }}
      >
        <Input type='text' name='name' label='Name' />
        <Input type='text' name='title' label='Title' />
        <Dropdown
          name='type'
          label='Type'
          options={lookups.types}
        />
        <Input type='text' name='email' label='E-Mail' />
        <Phone name='phone' label='Phone' />
        <Address />
        <Dropdown
          name='timezone'
          label='Timezone'
          options={lookups.timezones}
        />
      </Body>
      <Footer
        toggle={toggle}
        onAction={handleSubmit}
        action={{
          text: 'Save',
          icon: isLoading === true ? faSpinner : faSave,
          color: 'primary',
          disabled: disableSave === true || isLoading
        }}
      />
    </>
  )
}

export default Form
